// Dashboard.jsx
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Auth } from '../../Utils/Auth';
import Sidebar from '../sidebar/Sidebar';
import DashboardHeader from './dashboardheader/DashboardHeader';
import Parametres from '../../pages/Paramettre/Paramettre';
import Utilisateurs from '../../pages/Utilisateurs/Utilisateurs';
import Paiements from '../../pages/Paiement/Paiement';
import Annonces from '../../pages/Annonces/Annonces';
import './Dashboard.css';

const Dashboard = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        // Vérifier l'authentification
        if (!Auth.isLoggedIn()) {
            window.location.href = '/auth/login';
            return;
        }

        // Récupérer les informations utilisateur
        const userData = Auth.getUser();
        setUser(userData);
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    if (!user) {
        return (
            <div className="dashboard-loading">
                <div className="loading-spinner"></div>
                <p>Chargement...</p>
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

            <div className="dashboard-main">
                <DashboardHeader toggleSidebar={toggleSidebar} user={user} />

                <div className="dashboard-content">
                    <Routes>
                        <Route path="/" element={<Navigate to="/dashboard/annonces" replace />} />
                        <Route path="/annonces/*" element={<Annonces />} />
                        <Route path="/paiements" element={<Paiements />} />
                        <Route path="/utilisateurs" element={<Utilisateurs />} />
                        <Route path="/parametres" element={<Parametres />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;